import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';
import pointsMarkup from '../markup2/ads.js';
import toolsMarkup from '../markup/tools.js';

import cropWrap from '../tools/cropWrapper.js';

const loaderSpinnerId = 'loader-enterprises';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);
const body = document.querySelector('body');
const formAdd = body.querySelector('#modal_one_txt_only');
const form = formAdd.querySelector('#modal_one_txt_only-form');
const name = form.querySelector('#modal_one_txt_only-name');
const addName = form.querySelector('#modal_one_txt_only-txt');
const cardTitle = document.querySelector('#modal_one_txt_only-title');
const addNameSubmitButton = form.querySelector('#modal_one_txt_only-submit');

import modalInfo from '../lk-catalogs/modal_one_txt_only.js';
const cardAd = document.querySelector('#ads_card');
const cardAdPhoto = document.querySelector('#ads_card-photo');

const cardAdName = document.querySelector('#ads_card-name');

const cardAdURL = document.querySelector('#ads_card-url');
const cardAdActiveCheckBox = document.querySelector('#ads_card_radio_active_now');
const cardAdType = document.querySelector('#ads_card_type');
const cardAdPriority = document.querySelector('#ads_card_priority');

const cardAdAddChange = document.querySelector('#ads_card-Add-change');
// const cardAdUploadNewImage = document.querySelector('#ads_card_image-uploader');
const cardAdUploadNewImageElem = document.querySelector('#ads_card_image-uploader-Elem');

const mainTabPane = document.querySelector('#ads');
const mainTabPaneBTAdd = mainTabPane.querySelector('button[name=add]');
const mainTabPaneBTReload = mainTabPane.querySelector('button[name=refresh]');
const mainTabPaneBody = mainTabPane.querySelector('div[name=body]');

const menuBt =  document.querySelector('#MenuAds')


const cropWrapNode1 = cardAd.querySelector('#image-uploader-wrapper');
const cardPhotoSpinner = cardAd.querySelector('#uploadSpinner');


let filmImageToUpload1 = null;
let filmImageToDelete1 = false;

cropWrap.init(cropWrapNode1, false, {
  dataName: 'none',
  aspectRatio: 1.7,
  onSave: (blob) => {
    filmImageToUpload1 = blob;
    sentPhoto();
  },
  onDelete: () => {
    filmImageToDelete1 = true;
    deletePhoto();
  }
});

function deletePhoto() {
  xhr.request = {
    metod: 'DELETE',
    url: `ads/${cardAd.getAttribute('currentAd')}/photo/`,
    data: '',
    callbackSuccess: cleanImg
  };
};
const sentPhoto = () => {
  cardPhotoSpinner.style.opacity = 1;

  xhr.request = {
    metod: 'POST',
    url: `ads/${cardAd.getAttribute('currentAd')}/photo/`,
    // url: `imgSaver`,
    data: filmImageToUpload1,
    callbackSuccess: () => onSaveComplite()
  };
};


const onSaveComplite = () => {
  getAds();
  cardPhotoSpinner.style.opacity = 0;
};

const onSuccessPointsLoad = (loadedPoints) => {
  pointsMarkup.cleanContainer();
  if (loadedPoints.status === 200) {
    console.log(loadedPoints);
    pointsMarkup.drawDataInContainer(loadedPoints.data);
  } else {
    pointsMarkup.drawMarkupInContainer(`<p>${loadedPoints.message}</p>`);
  }
};

mainTabPaneBTReload.addEventListener('click', function () {
  getAds();
});

mainTabPaneBTAdd.addEventListener('click', function () {
  cardTitle.innerHTML = 'Создание рекламного блока';
  name.innerHTML = 'Добавить рекламный блок:';
  addName.innerHTML = '';
  addName.placeholder = 'Укажите название';
  addNameSubmitButton.innerHTML = 'Создать';
  modalInfo.start(`ads`, mainTabPaneBTReload, 'POST');
  $(formAdd).modal('show');
});

mainTabPaneBody.addEventListener('click', function (evt) {
  // определить тип на что нажали
  // console.log(evt.target);
  if (evt.target.attributes.advID) {
    cardAd.setAttribute('currentAd', evt.target.attributes.advID.nodeValue);
    clearCard();
    xhr.request = {
      metod: 'GET',
      url: `ads/${cardAd.getAttribute('currentAd')}`,
      data: '',
      callbackSuccess: onSuccessCardLoad
    };
  }
});

function clearCard() {
  // cardAdPhoto.src = '';
       // let path = `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/img/jury/${loadedPoints.data.image}.jpg`;
  cropWrap.setImg(cropWrapNode1, '');
  cardAdName.value = '';
  cardAdURL.value = '';

}
const getAds = () => {
  pointsMarkup.cleanContainer();
  pointsMarkup.drawMarkupInContainer(loaderSpinnerMarkup);

  cardPhotoSpinner.innerHTML = loaderSpinnerMarkup;

  xhr.request = {
    metod: 'GET',
    url: 'ads',
    data: '',
    callbackSuccess: onSuccessPointsLoad
  };
};


function forEach(data, callback) {
  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      callback(key, data[key]);
    }
  }
}


const onSuccessCardLoad = (loadedPoints) => {
// document.querySelector(`#${loaderSpinnerId}`).remove();
  if (loadedPoints.status === 200) {
    $(formAdd).modal('hide');
    cardAdAddChange.innerHTML = 'Изменить';

    cardPhotoSpinner.style.opacity = 0;
    if (loadedPoints.data.image && loadedPoints.data.image.length > 2) {
      let path = `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/img/ads/${loadedPoints.data.image}.jpg`;
      cropWrap.setImg(cropWrapNode1, path);
    }
    cardAdName.value = loadedPoints.data.name;
    cardAdURL.value = loadedPoints.data.url;
    cardAdType.value = loadedPoints.data.type;
    cardAdPriority.value = loadedPoints.data.priority;

    cardAdActiveCheckBox.value = loadedPoints.data.status;
    // if (parseInt(loadedPoints.data.ads_active, 10) === 1) {
    //   cardAdActiveCheckBox.checked = true;
    // }

    console.log(loadedPoints.data);
    $(cardAd).modal('show');
    // $('#datetimepicker1').datetimepicker();
    // $('#datetimepicker2').datetimepicker();

  }
};
cardAdAddChange.addEventListener('click', function () {

  xhr.request = {
    metod: 'PUT',
    url: `ads/${cardAd.getAttribute('currentAd')}`,
    data: `name=${cardAdName.value}&url=${cardAdURL.value}&status=${cardAdActiveCheckBox.value}&type=${cardAdType.value}&priority=${cardAdPriority.value}`,
    callbackSuccess: onSuccessAddLoad
  };
});

const onSuccessAddLoad = (loadedPoints) => {
// document.querySelector(`#${loaderSpinnerId}`).remove();
  if (loadedPoints.status === 200) {
    $(cardAd).modal('hide');
  }
};
function cleanImg() {

  cardPhotoSpinner.style.opacity = 0;
  // cardAdPhoto.src = 'http://festappbuilder.ru/content/festival/1/ads/1/ads.jpg';
}
export default {

  start() {
    // getAds();
    menuBt.addEventListener('click', getAds);
  },

  redraw: getAds,

  stop() {
    pointsMarkup.cleanContainer();
    menuBt.removeEventListener('click', getAds);
  }
};
